import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TokenListFullNameCell } from './token-list-full-name.cell';
import { TokenListFullNameHeader } from './token-list-full-name.header';

export const TokenListFullNameColumn: IdentifiedColumnDef<
  GatewayTokenModel,
  GatewayTokenModel['firstName']
> = {
  enableSorting: false,
  header: TokenListFullNameHeader,
  cell: TokenListFullNameCell,
};
